
namespace GeniuzPOS.Product {

    @Serenity.Decorators.registerClass()
    export class CsMatTypeGrid extends Serenity.EntityGrid<CsMatTypeRow, any> {
        protected getColumnsKey() { return CsMatTypeColumns.columnsKey; }
        protected getDialogType() { return CsMatTypeDialog; }
        protected getIdProperty() { return CsMatTypeRow.idProperty; }
        protected getInsertPermission() { return CsMatTypeRow.insertPermission; }
        protected getLocalTextPrefix() { return CsMatTypeRow.localTextPrefix; }
        protected getService() { return CsMatTypeService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected getButtons() {
            var buttons = super.getButtons();
            
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/';
                        return false;
                    },
                }
            );            
            return buttons;
        }
    }
}